import { lazy, useEffect, useState } from 'react';
import { DisclaimerType } from '../../../types';
import { fetchWithType } from '../../../utils/api';
import {
  getAdminUrl,
  getApiToken,
  locationIsKia,
} from '../../../utils/helpers';
import { AppProps } from '../../App';
import Snippet from '../../components/Snippet';

const DisclaimersControls = lazy(
  () => import('../../components/disclaimers/DisclaimersControls'),
);

export interface DisclaimersOptions {
  ids: number[];
}

const Disclaimers: React.FunctionComponent<
  Pick<AppProps, 'ids'> & { hideControls?: boolean }
> = ({ ids, hideControls = false }) => {
  const [options, setOptions] = useState<DisclaimersOptions>({
    ids: ids
      ? ids
          .replace(/&quot;|&#34;|&#x22;|["'“”‘’„]/gi, '')
          .split(',')
          .map((e: string) => Number(e.trim()))
          .filter((n: number) => !Number.isNaN(n) && n > 0)
      : [],
  });

  const [disclaimers, setDisclaimers] = useState<DisclaimerType[]>([]);

  const fetchDisclaimers = async () => {
    const { data } = await fetchWithType<DisclaimerType[]>(
      getAdminUrl() + '/api/disclaimers',
      {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${getApiToken()}`,
        },
      },
    );
    setDisclaimers(data);
  };

  const getSnippetProps: () => string = () => {
    return `ids="${options.ids.join(',')}"`;
  };

  useEffect(() => {
    fetchDisclaimers();
  }, []);

  const getById = (id: number) =>
    disclaimers.find((d: DisclaimerType) => d.id === id);

  return disclaimers?.length ? (
    <>
      {!locationIsKia() && !hideControls ? (
        <div className="pt-4 pb-4">
          <>
            <DisclaimersControls
              setOptions={setOptions}
              disclaimers={disclaimers}
            />
            <Snippet page="disclaimers" props={getSnippetProps()} />
          </>
        </div>
      ) : null}
      <div className="my-10 max-w-screen-kia-sm mx-auto px-4">
        {options.ids.map((d: number) => (
          <div
            key={d}
            className={`py-4 ${getById(d)?.background ? 'rounded-2xl bg-kia-grey px-2' : ''}`}
          >
            {!getById(d)?.vroom && (
              <h3>{`${getById(d)?.key}. ${getById(d)?.title}`}</h3>
            )}
            <p dangerouslySetInnerHTML={{ __html: getById(d)?.text }} />
          </div>
        ))}
      </div>
    </>
  ) : null;
};

export default Disclaimers;
